// extracted by mini-css-extract-plugin
export var addToCartButton = "_nx-b";
export var arrowButtonContainer = "_nx-9";
export var arrowButtonIcon = "_nx-a";
export var carouselArrowButton = "_nx-6";
export var carouselElementContainer = "_nx-1";
export var left = "_nx-7";
export var productDisplayCarouselContainer = "_nx-0";
export var productTileContainer = "_nx-2";
export var productTileImage = "_nx-4";
export var productTileImageContainer = "_nx-3";
export var productTileTitle = "_nx-5";
export var right = "_nx-8";
export var sliderOverflow = "_nx-c";